import styled, { css } from 'styled-components';

export const TransportDetailsContainer = styled.div<{ $desktop: boolean }>`
  ${({ $desktop }) =>
    $desktop &&
    css`
      height: 100%;
      box-shadow: ${({ theme }) => theme.kallisto.shadow.mediumDownShadow};
    `};

  ${({ $desktop }) =>
    !$desktop &&
    css`
      border-bottom-right-radius: 8px;
    `};

  width: 100%;
  padding: 16px 24px 16px 16px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: 24px;
  cursor: pointer;
  border-bottom-left-radius: 8px;
`;

export const BaggageContainer = styled.div`
  display: flex;
`;

export const Separator = styled.div`
  background-color: ${({ theme }) => theme.kallisto.color.border.static.borderDisabled};
  width: 100%;
  height: 1px;
`;
